module.exports = __webpack_public_path__ + "static/media/homePageImg-01.dcd76876.jpg";